import { api as LoginApi } from 'app/pages/Login/slice';
import { api as signupApi } from 'app/pages/Signup/slice';
import { api as mediaApi } from 'app/pages/Media/slice';
import { api as usersApi } from 'app/pages/Users/slice';
import { api as userPackagesReportsApi } from 'app/pages/UserPackagesReports/slice';
import { api as FilesApi } from 'app/pages/Files/slice';
import { api as downloadPackagesApi } from 'app/pages/DownloadPackages/slice';
import { api as ordersApi } from 'app/pages/Orders/slice';
import { api as orderDetailsApi } from 'app/pages/OrderDetails/slice';
import { api as dashboardApi } from 'app/pages/Dashboard/slice';
import { api as managePagesApi } from 'app/pages/ManagePages/slice';
import { api as blogsApi } from 'app/pages/Blogs/slice';
import { api as requestFileApi } from 'app/pages/RequestFiles/slice';
import { api as agentsApi } from 'app/pages/Agents/slice';
import { api as reviewsApi } from 'app/pages/Reviews/slice';

import { api as productsApi } from 'app/pages/Product/slice';
import { api as videosApi } from 'app/pages/Videos/slice';
import { api as userchatApi } from 'app/pages/Users/Chat/slice';
import { api as globalApi } from 'app/slice';
import { api as currenciesApi } from 'app/pages/Currencies/slice';
import { api as courseApi } from 'app/pages/Course/slice';
import { api as usersAccountApi } from 'app/pages/Users/Account/slice';
import { api as courseDetailsApi } from 'app/pages/CourseDetails/slice';
import { api as transactionApi } from 'app/pages/Transactions/slice';
import { api as downloadsHistoryApi } from 'app/pages/DownloadsHistory/slice';
import { api as menuManagementApi } from 'app/pages/MenuManagement/slice';
import { api as bannerManagementApi } from 'app/pages/BannerManagement/slice';
import { api as errorLogsApi } from 'app/pages/ErrorLogs/slice';
import { api as notificationsApi } from 'app/pages/Notifications/slice';
import { api as apiManagerApi } from 'app/pages/ApiManager/slice';
import { api as siteSettingsApi } from 'app/pages/Settings/SiteSettings/slice';
import { api as profileApi } from 'app/pages/Profile/slice';
import { api as paymentMethodsApi } from 'app/pages/PaymentMethods/slice';
import { api as teamsApi } from 'app/pages/Teams/slice';
import { api as emailConfigApi } from 'app/pages/EmailConfiguration/slice';
import { api as contactUsEnquiryApi } from 'app/pages/ContactUsEnquiry/slice';
import { api as socialLinksApi } from 'app/pages/SocialLinks/slice';
import { api as seoApi } from 'app/pages/SeoSettings/slice';
import { api as adminsApi } from 'app/pages/Admins/slice';
import { api as taxManagementApi } from 'app/pages/TaxManagement/slice';
import { api as couponDiscountsApi } from 'app/pages/CouponDiscounts/slice';
import { offlinePaymentApi as offlinePaymentMethodsApi } from 'app/pages/OfflinePaymentMethods/slice';
import { api as fileManagerApi } from 'app/pages/FileManager/slice';
import { api as supplierManagementApi } from 'app/pages/SupplierManagement/slice';
import { invoiceApi } from 'app/pages/Reports/Invoices/slice';
import { api as inventoryApi } from 'app/pages/InventoryManagement/slice';
import { api as telegramBotConfigApi } from 'app/pages/TelegramBotConfiguration/slice';

export const rtkQueryMiddleware = [
  globalApi.middleware,
  LoginApi.middleware,
  signupApi.middleware,
  mediaApi.middleware,
  usersApi.middleware,
  userPackagesReportsApi.middleware,
  FilesApi.middleware,
  downloadPackagesApi.middleware,
  ordersApi.middleware,
  orderDetailsApi.middleware,
  dashboardApi.middleware,
  managePagesApi.middleware,
  teamsApi.middleware,
  blogsApi.middleware,
  requestFileApi.middleware,
  agentsApi.middleware,
  reviewsApi.middleware,
  productsApi.middleware,
  videosApi.middleware,
  userchatApi.middleware,
  currenciesApi.middleware,
  courseApi.middleware,
  usersAccountApi.middleware,
  courseDetailsApi.middleware,
  transactionApi.middleware,

  downloadsHistoryApi.middleware,
  menuManagementApi.middleware,
  bannerManagementApi.middleware,
  errorLogsApi.middleware,
  notificationsApi.middleware,

  apiManagerApi.middleware,
  siteSettingsApi.middleware,
  profileApi.middleware,
  paymentMethodsApi.middleware,
  emailConfigApi.middleware,
  contactUsEnquiryApi.middleware,
  socialLinksApi.middleware,
  seoApi.middleware,
  adminsApi.middleware,
  taxManagementApi.middleware,
  couponDiscountsApi.middleware,
  offlinePaymentMethodsApi.middleware,
  fileManagerApi.middleware,
  supplierManagementApi.middleware,
  invoiceApi.middleware,
  inventoryApi.middleware,
  telegramBotConfigApi.middleware,
];
